<template>
    <div class="accordion-item">
        <h3 class="accordion-header" id="class-header">
            <button class="accordion-button d-flex" type="button" data-bs-toggle="collapse" data-bs-target="#worksheet-collapse" aria-expanded="true" aria-controls="worksheet-collapse">
                <span class="flex-grow-1">My Checklists</span>
                <span></span>
            </button>
        </h3>
        <div id="worksheet-collapse" class="accordion-collapse collapse" aria-labelledby="class-header" data-bs-parent="#accordion-filter-options" ref="accbody">
            <div class="accordion-body">
                <div class="list-group list-group-selectable">
                    <div v-for="ws in worksheets" class="list-group-item" @click="show(ws.id)">
                        {{ ws.name }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueCookies from 'vue-cookies';

export default {
components: { VueCookies },

mounted() {
    this.$parent.isLoading = true;
    axios
        .get('/api/worksheet')
        .then(response => {
            console.log(response.data);
            this.worksheets = response.data;
        })
        .catch(error => {
            console.error(error);
        })
        .finally(() => {
            this.$parent.isLoading = false;
        })
    
    if (VueCookies.isKey('ws')) {
        try {
            this.selected = VueCookies.get('wsl');
        } catch (e) {
            console.warn('Worksheet: Bad cookie data');
            VueCookies.remove('ws');
        }
    }

    this.$refs.accbody.addEventListener('hide.bs.collapse', event => {
        VueCookies.set('ws', this.selected, Infinity);
    });
},

methods: {
    show: function(id) {
        //window.location.assign(`/#/worksheet?ws=${id}`);
        this.$router.push(`/worksheet?ws=${id}`);
    }
},

data() {
    return {
        worksheets: [],
        selected: {
            id: 1
        }
    }
}
}
</script>